// Module
var code = "<div class=\"ui-grid-cell-contents u-sizeFullWidth u-textRight\" smart-truncate ng-bind=\"row.entity[col.field]\"></div>\n";
// Exports
module.exports = code;